module.exports = __webpack_public_path__ + "media/images/colorpicker/transparent-b5b148e68ecbe4238f3ac6569a94f57e.png";